<template>
  <div>
    <v-row>
      <v-col>
        <v-card-title>Assets</v-card-title>
        <v-simple-table dark>
          <template v-slot:default>
            <thead>
            <tr>
              <th class="text-left">
                Domain
              </th>
              <th class="text-left">
                Count
              </th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="item in domains_have_most_assets"
                :key="item.domain"
            >
              <td>{{ item.domain }}</td>
              <td>{{ item.count }}</td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card-title>Subdomains</v-card-title>
        <v-simple-table dark>
          <template v-slot:default>
            <thead>
            <tr>
              <th class="text-left">
                Domain
              </th>
              <th class="text-left">
                Count
              </th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="item in domains_have_most_subdomains"
                :key="item.domain"
            >
              <td>{{ item.domain }}</td>
              <td>{{ item.count }}</td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </div>
</template>


<script>

export default {
  name: "top-domains",
  data() {
    return {
      domains_have_most_assets: [],
      domains_have_most_subdomains: [],
    }
  },
  mounted() {
    this.axios.get('https://isee.sh:2087/top-domains/statistics').then(response => {
      this.domains_have_most_subdomains = response.data.domains_have_most_subdomains
      this.domains_have_most_assets = response.data.domains_have_most_assets
    })

  }
}

</script>

<style scoped>

</style>